import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FDF4FF] pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-175">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -z-10 w-1/2 h-full bg-gradient-to-bl from-[#F5D0FE]/40 to-transparent rounded-bl-[100px] hidden lg:block" data-id="element-176" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-178">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-179">
            <div className="flex flex-wrap gap-2 mb-6" data-id="element-180">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#D946EF]/15 text-[#A21CAF]" data-id="element-181">
                Guía paso a paso
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#D946EF]/15 text-[#A21CAF]" data-id="element-182">
                Acceso inmediato
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-[#D946EF]/15 text-[#A21CAF]" data-id="element-183">
                Para dueños ocupados
              </span>
            </div>

            <h1 className="text-4xl lg:text-6xl font-bold text-[#2D2D2D] leading-tight mb-4" data-id="element-184">
              7 días para un{' '}
              <span className="text-[#D946EF]" data-id="element-185">bowl perfecto</span>
            </h1>
            <p className="text-xl text-[#4A4A4A] mb-6 font-medium" data-id="element-186">
              Digestión, energía y rutina para tu Frenchie
            </p>

            <p className="text-lg text-[#666666] mb-8 leading-relaxed" data-id="element-187">
              Menos gases. Más energía. Menos alergias, más saludable con
              recetas sin estrés. Un sistema claro para ordenar su rutina de
              comida sin adivinar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-188">
              <Button size="lg" icon={ArrowRight} href="#que-incluye" data-id="element-189">
                Ver lo que incluye
              </Button>
            </div>

            <div className="flex flex-wrap gap-4 text-sm text-[#4A4A4A]" data-id="element-190">
              {['Rutina clara', 'Recetas saludables', 'Ingredientes caseros'].map((item, i) => <div key={i} className="flex items-center bg-white px-4 py-2 rounded-lg shadow-sm border border-[#F5D0FE]" data-id="element-191">
                  <CheckCircle2 className="w-4 h-4 text-[#D946EF] mr-2" data-id="element-192" />
                  {item}
                </div>)}
            </div>
          </motion.div>

          {/* Image/Product Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-193">
            <div className="relative z-10 bg-white rounded-3xl shadow-xl p-6 md:p-8 max-w-md mx-auto transform rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-194">
              <div className="absolute -top-4 -right-4 bg-[#D946EF] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg z-20" data-id="element-195">
                Bowl Upgrade
              </div>

              <div className="aspect-[4/5] rounded-2xl overflow-hidden mb-6 bg-[#FAE8FF] relative group" data-id="element-196">
                <img src="https://cdn.magicpatterns.com/uploads/dJdYiEpKUMe93F9Fk2Buq6/libro_pricipAL_2.png" alt="Mejora del Tazón en 7 Días Book Cover" className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500" data-id="element-197" />
              </div>

              <div className="flex items-center justify-between mb-4" data-id="element-198">
                <div className="flex items-center space-x-1" data-id="element-199">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-200" />)}
                  <span className="ml-2 text-sm font-bold text-[#2D2D2D]" data-id="element-201">
                    4.9
                  </span>
                </div>
                <span className="text-sm text-[#666666]" data-id="element-202">Acceso inmediato</span>
              </div>

              <Button fullWidth variant="secondary" onClick={() => window.open('https://bullygooddogs.com/cart/51339283890493:1/checkout', '_blank')} data-id="element-203">
                Quiero el sistema
              </Button>
            </div>

            {/* Decorative background blob */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#D946EF]/15 rounded-full blur-3xl -z-10" data-id="element-204" />
          </motion.div>
        </div>
      </div>
    </section>;
}